import { useState } from "react";
import { Play, Quote } from "lucide-react";
import Reveal from "./Reveal";

const TESTIMONIALS = [
    {
        name: "Lewis",
        stat: "RD$493,000",
        tag: "174 pedidos · en 2 semanas",
        quote: "No podía ni creer mis resultados. Nunca había visto tanto dinero — y llevaba solo 2 semanas.",
    },
    {
        name: "Morelia",
        stat: "RD$250,000",
        tag: "de ganancia en 1 mes",
        quote: "En un solo mes facturé 800 mil pesos y me quedé con 250 mil de ganancia. Esto es real.",
    },
    {
        name: "Rafael",
        stat: "$10,000 USD",
        tag: "sus primeros · en 2025",
        quote: "Logré mis primeros $10,000 dólares. Lo que parecía imposible se volvió real siguiendo el sistema.",
    },
    {
        name: "Ann",
        stat: "Resultados reales",
        tag: "con el sistema",
        quote: "Empecé sin saber nada y con el acompañamiento del equipo logré resultados que no creía posibles.",
    },
];

const YOUTUBE_VIDEOS = [
    { id: "3C5DoP96Ph8", name: "Lewis", note: "174 pedidos en 2 semanas" },
    { id: "jBqn04nImlc", name: "Morelia", note: "RD$800,000 facturados" },
    { id: "jhsmB-aWOao", name: "Rafael", note: "Sus primeros $10,000 USD" },
    { id: "ncqmxroY--w", name: "Ann", note: "Resultados con el sistema" },
];

function YoutubeFacade({ video, index }) {
    const [playing, setPlaying] = useState(false);

    return (
        <div
            className="card-hover relative aspect-video overflow-hidden rounded-2xl border border-[#222] bg-[#111]"
            data-testid={`youtube-facade-${index}`}
        >
            {playing ? (
                <iframe
                    src={`https://www.youtube.com/embed/${video.id}?autoplay=1`}
                    className="absolute inset-0 h-full w-full"
                    frameBorder="0"
                    allow="autoplay; encrypted-media; picture-in-picture"
                    allowFullScreen
                    title={`Testimonio de ${video.name}`}
                />
            ) : (
                <button
                    onClick={() => setPlaying(true)}
                    className="group absolute inset-0 cursor-pointer"
                    aria-label={`Ver testimonio de ${video.name}`}
                >
                    <img
                        src={`https://i.ytimg.com/vi/${video.id}/hqdefault.jpg`}
                        alt={`Testimonio de ${video.name}`}
                        loading="lazy"
                        className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                    <span className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d]/95 via-[#0d0d0d]/20 to-[#0d0d0d]/40" />
                    <span className="absolute inset-0 flex items-center justify-center">
                        <span className="flex h-12 w-12 items-center justify-center rounded-full border border-[#ff5c00]/50 bg-[#0d0d0d]/75 backdrop-blur-sm transition-transform duration-300 group-hover:scale-110">
                            <Play className="ml-0.5 h-5 w-5 fill-[#ff5c00] text-[#ff5c00]" />
                        </span>
                    </span>
                    <span className="absolute bottom-0 left-0 p-4 text-left">
                        <span className="font-display block text-base font-bold">{video.name}</span>
                        <span className="block text-xs text-[#aaa]">{video.note}</span>
                    </span>
                </button>
            )}
        </div>
    );
}

export default function Testimonials() {
    return (
        <section className="relative overflow-hidden px-5 py-20 sm:py-28" data-testid="testimonials-section">
            <span className="chapter-num absolute -top-4 right-2 text-[9rem] sm:text-[13rem]" aria-hidden="true">
                01
            </span>
            <div className="relative mx-auto max-w-6xl">
                <Reveal>
                    <div className="mb-4 flex items-center gap-2">
                        <span className="dot-blink h-1.5 w-1.5 rounded-full bg-[#22c55e]" />
                        <span className="text-xs font-medium uppercase tracking-[0.2em] text-[#888]">Resultados reales</span>
                    </div>
                    <h2 className="font-display max-w-2xl text-3xl font-extrabold leading-[1.08] sm:text-5xl">
                        Lo que dicen nuestros <em className="serif-accent text-grad">estudiantes</em>
                    </h2>
                </Reveal>

                <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                    {TESTIMONIALS.map((t, i) => (
                        <Reveal key={t.name} delay={i * 90}>
                            <article
                                className="card-hover flex h-full flex-col rounded-2xl border border-[#222] bg-[#111111] p-6"
                                data-testid={`testimonial-card-${t.name.toLowerCase()}`}
                            >
                                <div className="mb-5 flex items-center justify-between">
                                    <span className="font-display text-sm font-bold">{t.name}</span>
                                    <span className="rounded-full border border-[#2a2a2a] bg-[#0d0d0d] px-2.5 py-1 text-[10px] font-medium text-[#22c55e]">
                                        {t.tag}
                                    </span>
                                </div>
                                <p className="font-display text-grad text-3xl font-extrabold tracking-tight">{t.stat}</p>
                                <p className="mt-4 flex-1 text-sm leading-relaxed text-[#999]">“{t.quote}”</p>
                                <Quote className="mt-5 h-4 w-4 text-[#333]" />
                            </article>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={100} className="mt-14">
                    <p className="mb-5 text-xs font-medium uppercase tracking-[0.2em] text-[#888]">Testimonios en video</p>
                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                        {YOUTUBE_VIDEOS.map((v, i) => (
                            <YoutubeFacade key={v.name} video={v} index={i} />
                        ))}
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
